const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#268A66',
      light: '#E6F5F0',
      dark: '#1E6B4F',
    },
    secondary: {
      main: '#18322E',
      light: '#E8EDEB',
      dark: '#0F1F1C',
    },
    success: {
      main: '#268A66',
      light: '#E6F5F0',
      dark: '#1E6B4F',
      contrastText: '#ffffff',
    },
    info: {
      main: '#268A66',
      light: '#E6F5F0',
      dark: '#1E6B4F',
      contrastText: '#ffffff',
    },
    error: {
      main: '#f80400',
      light: '#FDE8E3',
      dark: '#C63E1A',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FBAD17',
      light: '#FEF5E3',
      dark: '#C88912',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#F2F6FA',
      200: '#EAEFF4',
      300: '#DFE5EF',
      400: '#7C8FAC',
      500: '#5A6A85',
      600: '#2A3547',
    },
    text: {
      primary: '#18322E',
      secondary: '#18322E',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#f6f9fc',
    },
    divider: '#e5eaef',
    background: {
      default: '#ffffff',
    },
  },
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#268A66',
      light: '#1A5A44',
      dark: '#1E6B4F',
    },
    secondary: {
      main: '#18322E',
      light: '#0F1F1C',
      dark: '#0A1412',
    },
    success: {
      main: '#268A66',
      light: '#1A5A44',
      dark: '#1E6B4F',
      contrastText: '#ffffff',
    },
    info: {
      main: '#268A66',
      light: '#1A5A44',
      dark: '#1E6B4F',
      contrastText: '#ffffff',
    },
    error: {
      main: '#f80400',
      light: '#4B1F14',
      dark: '#C63E1A',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FBAD17',
      light: '#4D3A1A',
      dark: '#C88912',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#333F55',
      200: '#465670',
      300: '#7C8FAC',
      400: '#DFE5EF',
      500: '#EAEFF4',
      600: '#F2F6FA',
      A700: '#465670',
    },
    text: {
      primary: '#EAEFF4',
      secondary: '#7C8FAC',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#333F55',
    },
    divider: '#333F55',
    background: {
      default: '#171c23',
      dark: '#171c23',
      paper: '#171c23',
    },
  },
};

export { baseDarkTheme, baselightTheme };
